import { render, staticRenderFns } from "./Diferenciais.vue?vue&type=template&id=4bee663c&"
import script from "./Diferenciais.vue?vue&type=script&lang=js&"
export * from "./Diferenciais.vue?vue&type=script&lang=js&"
import style0 from "./Diferenciais.vue?vue&type=style&index=0&id=4bee663c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports